import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams, useLocation, Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { useMemo } from "react";
import { Button } from "react-bootstrap";
import Select from "react-select";
import swal from "sweetalert";
import { createMedicineAction, updateMedicineAction } from "../../../store/actions/MedicinesAction";
import { showErrorAlert } from "../../../services/ErrorHandlingService";
import Loader from "../Common/Loader";
import { getDefaultDoseAction } from "../../../store/actions/DefaultDoseAction";
import { getFrequencyAction } from "../../../store/actions/FrequencyAction";
import { getUnitOfDoseAction } from "../../../store/actions/UnitOfDoseAction";
import { getAnupanList, formatAnupans } from "../../../services/AnupanService";
import { getPathyaAction } from "../../../store/actions/PathyaActions";
import { getMedicineTypes } from "../../../services/MedicineTypeService";
import { getHowToTakeAction } from "../../../store/actions/HowToTakeAction";
const prescriptionOptions = [
  { value: "yes", label: "Yes" },
  { value: "no", label: "No" },
];

const AddMedicine = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const medicineData = location.state?.medicine || null;
  // const [defaultDoseOptions, setDefaultDoseOptions] = useState([]);
  // const [frequencyOptions, setFrequencyOptions] = useState([]);
  // const [unitOfMeasureOptions, setUnitOfMeasureOptions] = useState([]);
  const [anupanOptions, setAnupanOptions] = useState([]);

  const unitDoses = useSelector(
    (state) => state.unitDose?.units || []
  );


  const defaultDoses = useSelector(
    (state) => state.defaultDose?.doses || []
  );
  const frequencies = useSelector(
    (state) => state.frequency?.list || []
  );

  const pathyas = useSelector(
    (state) => state.pathya?.list || []
  );

  const howToTakeList = useSelector(
    (state) => state.howToTake?.list || []
  );

  useEffect(() => {
    console.log("howToTakeList:", howToTakeList);
  }, [howToTakeList]);


  const [medicineTypes, setMedicineTypes] = useState([]);

  const pathyaOptions = useMemo(() => {
    return Array.isArray(pathyas)
      ? pathyas
        .filter((p) => p.pathya_status === "Active")
        .map((p) => ({
          value: p.pathya_name,   // ✅ correct
          label: p.pathya_name,   // ✅ correct
          id: p.pathya_id,
        }))
      : [];
  }, [pathyas]);


  const defaultDoseOptions = useMemo(() => {
    return Array.isArray(defaultDoses)
      ? defaultDoses
        .filter((d) => d.dose_status === "Active")
        .map((d) => ({
          value: d.dose_text,
          label: d.dose_text,
          id: d.id,
        }))
      : [];
  }, [defaultDoses]);

  const frequencyOptions = useMemo(() => {
    return Array.isArray(frequencies)
      ? frequencies
        .filter((f) => f.frequency_status === "Active")
        .map((f) => ({
          value: f.frequency_text,
          label: f.frequency_text,
          id: f.frequency_id,
        }))
      : [];
  }, [frequencies]);

  const unitOfMeasureOptions = useMemo(() => {
    return Array.isArray(unitDoses)
      ? unitDoses
        .filter((u) => u.unit_status === "Active")
        .map((u) => ({
          value: u.unit_text,
          label: u.unit_text,
          id: u.id,
        }))
      : [];
  }, [unitDoses]);

  const howToTakeOptions = useMemo(() => {
    return Array.isArray(howToTakeList)
      ? howToTakeList
        .filter((h) => h.status === "Active")
        .map((h) => ({
          value: String(h.id),
          label: h.text,
        }))
      : [];
  }, [howToTakeList]);


  const [medicine, setMedicine] = useState({
    id: "",
    medicineCode: "",
    medicineName: "",
    marathiName: "",
    displayName: "",              // ✅ ADD
    displayMarathiName: "",
    type: "",
    typeId: "0",
    defaultDose: "",
    defaultDoseId: "0",
    defaultFrequency: "",
    defaultFrequencyId: "0",
    defaultInstructions: "",
    howToTakeIds: [],        // ✅ NEW
    packageQty: "",
    unitOfMeasure: "",
    unitOfMeasureId: "0",
    valuePerUnit: "",
    pathyas: "",
    pathyasId: "0",
    anupanId: "",
    manufacturer: "",
    price: "",
    cgst: "",
    sgst: "",
    gst: "",
    finalPricecgstsgst: "",
    prescriptionRequired: "",
    status: "",
    minimum_threshold: "",
    isInternal: true,
  });
  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(false);
  const [errors, setErrors] = useState({});
  useEffect(() => {
    if (id && medicineData) {
      setFetching(true);
      setErrors({});
      setMedicine({
        id: medicineData.medicine_id,
        medicineCode: medicineData.medicine_code || "",
        medicineName: medicineData.medicine_name || "",
        marathiName: medicineData.marathi_corrected_name || "",
        displayName: medicineData.display_name_en || "",
        displayMarathiName: medicineData.display_name_mr || "",
        type: medicineData.medicine_type_text || "",
        typeId: medicineData.medicine_type_id || "0",
        defaultDose: medicineData.dose_text || "",
        defaultDoseId: medicineData.default_dose_id || "0",
        defaultFrequency: medicineData.frequency_text || "",
        defaultFrequencyId: medicineData.default_frequency_id || "0",
        defaultInstructions: medicineData.default_instructions || "",
        howToTakeIds: medicineData.how_to_take_id
          ? medicineData.how_to_take_id.split(",").map(String)
          : [],

        packageQty: medicineData.package_qty || "",
        unitOfMeasure: medicineData.unit_text || "",
        unitOfMeasureId: medicineData.unit_of_measure_id || "0",
        valuePerUnit: medicineData.value_per_unit || "",
        pathyas: medicineData.pathya_name || "",
        pathyasId: medicineData.pathyas_id || "0",
        anupanId: medicineData.anupana_id || "",
        manufacturer: medicineData.manufacturer || "",
        price: medicineData.base_price || "",
        cgst: medicineData.CGST || "",
        sgst: medicineData.SGST || "",
        gst: ((parseFloat(medicineData.CGST) || 0) + (parseFloat(medicineData.SGST) || 0)).toString(),
        finalPricecgstsgst: medicineData.cgst_sgst_price || "",
        prescriptionRequired: String(medicineData.prescription_required).toLowerCase(),
        status: medicineData.medicine_status || "",
        minimum_threshold: medicineData.minimum_threshold || "",
        isInternal: medicineData.is_internal === 1 || String(medicineData.medicine_int_ext_type).toLowerCase() === "internal",

      });
      setFetching(false);
    }
  }, [id, medicineData]);

  const calculateFinalPriceCGSTSGST = (price, cgst, sgst) => {
    return (price + (price * cgst) / 100 + (price * sgst) / 100).toFixed(2);
  };

  const calculateGST = (cgst, sgst) => {
    return (parseFloat(cgst) || 0) + (parseFloat(sgst) || 0);
  };

  useEffect(() => {
    getAnupanList(false)
      .then((res) => {
        if (res?.data?.status === "success") {
          const options = formatAnupans(res.data.data)
            .filter((a) => a.anupana_status === "Active")
            .map((a) => ({
              value: a.id,
              label: a.anupana_text,
              id: a.id,
            }));

          setAnupanOptions(options);
        }
      })
      .catch(() => {
        showErrorAlert("Failed to load Anupan list");
      });
  }, []);

  useEffect(() => {
    getMedicineTypes(false,0)
      .then((res) => {
        if (res?.data?.data) {
          const types = Array.isArray(res.data.data)
            ? res.data.data.map((type) => ({
              value: type.medicine_type_text,
              label: type.medicine_type_text,
              id: type.medicine_type_id,
            }))
            : [];
          setMedicineTypes(types);
        }
      })
      .catch(() => {
        showErrorAlert("Failed to load medicine types");
      });
  }, []);

  useEffect(() => {
    dispatch(getDefaultDoseAction(false));
    dispatch(getFrequencyAction(false));
    dispatch(getUnitOfDoseAction(false));
    dispatch(getPathyaAction(false));
    dispatch(getHowToTakeAction(false));
  }, [dispatch]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const parsedValue = value === "" ? "" : parseFloat(value);

    clearFieldError(name);

    setMedicine((prev) => {
      const updated = { ...prev, [name]: parsedValue };

      if (name === "price" && parsedValue < 0) return prev;

      if (name === "finalPricecgstsgst") {
        const gst = (parseFloat(updated.cgst) || 0) + (parseFloat(updated.sgst) || 0);
        if (gst > 0) {
          updated.price = parseFloat((parseFloat(updated.finalPricecgstsgst) / (1 + gst / 100)).toFixed(2));
        }
      } else if (name === "cgst" || name === "sgst") {
        updated.gst = calculateGST(updated.cgst, updated.sgst);
        updated.finalPricecgstsgst = calculateFinalPriceCGSTSGST(
          parseFloat(updated.price) || 0,
          parseFloat(updated.cgst) || 0,
          parseFloat(updated.sgst) || 0
        );
      } else if (name === "price") {
        updated.finalPricecgstsgst = calculateFinalPriceCGSTSGST(
          parseFloat(updated.price) || 0,
          parseFloat(updated.cgst) || 0,
          parseFloat(updated.sgst) || 0
        );
      }

      return updated;
    });
  };

  const handleTextChange = (e) => {
    const { name, value } = e.target;
    setMedicine((prev) => ({ ...prev, [name]: value }));
    clearFieldError(name);
  };

  function clearFieldError(field) {
    setErrors((prev) => {
      if (!prev || typeof prev !== "object") return prev;
      const keyToClear = field === "anupanId" ? "anupan" : field;
      if (!prev[keyToClear]) return prev;
      const { [keyToClear]: _removed, ...rest } = prev;
      return rest;
    });
  }

  const validate = () => {
    const newErrors = {};

    if (!medicine.medicineName || !medicine.medicineName.trim()) {
      newErrors.medicineName = "Enter Medicine name";
    }

    if (!medicine.medicineCode || !medicine.medicineCode.trim()) {
      newErrors.medicineCode = "Medicine Code is required";
    } else if (!/^[a-zA-Z0-9]+$/.test(medicine.medicineCode)) {
      newErrors.medicineCode = "Medicine Code must be alphanumeric";
    }

    if (!medicine.marathiName || !medicine.marathiName.trim()) {
      newErrors.marathiName = "Enter Marathi Name";
    }

    if (!medicine.displayName || !medicine.displayName.trim()) {
      newErrors.displayName = "Enter Display Name (English)";
    }

    if (!medicine.displayMarathiName || !medicine.displayMarathiName.trim()) {
      newErrors.displayMarathiName = "Enter Display Name (Marathi)";
    }

    if (!medicine.type) {
      newErrors.type = "Select Type";
    }

    if (!medicine.typeId || medicine.typeId === "0") {
      newErrors.type = "Select a valid Type";
    }

    if (!medicine.defaultDose) {
      newErrors.defaultDose = "Enter or Select Default Dose";
    }

    if (!medicine.defaultDoseId || medicine.defaultDoseId === "0") {
      newErrors.defaultDose = "Select a valid Default Dose";
    }

    if (!medicine.defaultFrequency) {
      newErrors.defaultFrequency = "Enter Default Frequency";
    }

    if (!medicine.defaultFrequencyId || medicine.defaultFrequencyId === "0") {
      newErrors.defaultFrequency = "Select a valid Default Frequency";
    }

    if (!medicine.defaultInstructions || !medicine.defaultInstructions.trim()) {
      newErrors.defaultInstructions = "Enter Default Instructions";
    }

    if (!medicine.howToTakeIds.length) {
      newErrors.howToTakeIds = "Select How To Take";
    }

    if (!medicine.packageQty) {
      newErrors.packageQty = "Package quantity required";
    }

    if (!medicine.unitOfMeasure || !medicine.unitOfMeasure.trim()) {
      newErrors.unitOfMeasure = "Enter Unit Of Measure";
    }

    if (!medicine.unitOfMeasureId || medicine.unitOfMeasureId === "0") {
      newErrors.unitOfMeasure = "Select a valid Unit of Measure";
    }

    if (!medicine.valuePerUnit) {
      newErrors.valuePerUnit = "Required Value Per Unit";
    }

    if (!medicine.pathyas || !medicine.pathyas.trim()) {
      newErrors.pathyas = "Enter Pathyas";
    }

    if (!medicine.pathyasId || medicine.pathyasId === "0") {
      newErrors.pathyas = "Select a valid Pathya";
    }

    if (!medicine.anupanId || medicine.anupanId === "0") {
      newErrors.anupan = "Select Anupan";
    }

    if (!medicine.manufacturer || !medicine.manufacturer.trim()) {
      newErrors.manufacturer = "Enter Manufacturer";
    }

    if (!medicine.prescriptionRequired) {
      newErrors.prescriptionRequired = "Select at least one option";
    }

    if (!medicine.price) {
      newErrors.price = "Enter Price";
    }

    if (!medicine.cgst && medicine.cgst !== 0) {
      newErrors.cgst = "Enter CGST (%)";
    }

    if (!medicine.sgst && medicine.sgst !== 0) {
      newErrors.sgst = "Enter SGST (%)";
    }

    if (!medicine.status) {
      newErrors.status = "Status is required";
    }

    if (!medicine.minimum_threshold && medicine.minimum_threshold !== 0) {
      newErrors.minimum_threshold = "Minimum threshold is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setErrors({});

    if (!validate()) {
      setLoading(false);
      return;
    }

    const action = id ? updateMedicineAction(medicine) : createMedicineAction(medicine);

    dispatch(action)
      .then(() => {
        setLoading(false);
        navigate("/medicines");
      })
      .catch(() => {
        setLoading(false);
      })
  };

  if (fetching) {
    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor: "rgba(255, 255, 255, 0.7)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 9999,
        }}
      >
        <Loader size="lg" />
      </div>
    );
  }

  return (
    <div className="row">
      <div className="col-xl-12">
        <div className="d-flex justify-content-end p-3">
          <Link to="/medicines">
            <Button variant="primary">Back</Button>
          </Link>
        </div>
        <div className="card">
          <div className="card-body">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-xl-4 mb-3">
                  <label htmlFor="id" className="form-label">
                    Medicine Code <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="medicineCode"
                    name="medicineCode"
                    pattern="[a-zA-Z0-9]+"
                    value={medicine.medicineCode}
                    onChange={handleTextChange}
                    maxLength="20"
                  //required
                  />
                  {errors.medicineCode && (
                    <div className="text-danger d-block mb-2">{errors.medicineCode}</div>
                  )}
                </div>
                <div className="col-xl-4 mb-3">
                  <label htmlFor="medicineName" className="form-label">
                    Admin Name (English)<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="medicineName"
                    name="medicineName"
                    value={medicine.medicineName}
                    onChange={handleTextChange}
                  //required
                  />
                  {errors.medicineName && (
                    <div className="text-danger d-block mb-2">{errors.medicineName}</div>
                  )}
                </div>
                <div className="col-xl-4 mb-3">
                  <label htmlFor="marathiName" className="form-label">
                    Admin Name (Marathi) <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="marathiName"
                    name="marathiName"
                    value={medicine.marathiName}
                    onChange={handleTextChange}
                  // required
                  />
                  {errors.marathiName && (
                    <div className="text-danger d-block mb-2">{errors.marathiName}</div>
                  )}
                </div>
              </div>
              <div className="row">
                <div className="col-xl-4 mb-3">
                  <label htmlFor="id" className="form-label">
                    Display Name (English) <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="displayName"
                    name="displayName"
                    value={medicine.displayName}
                    onChange={handleTextChange}
                  />
                  {errors.displayName && (
                    <div className="text-danger d-block mb-2">{errors.displayName}</div>
                  )}
                </div>
                <div className="col-xl-4 mb-3">
                  <label htmlFor="medicineName" className="form-label">
                    Display Name (Marathi)<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="displayMarathiName"
                    name="displayMarathiName"
                    value={medicine.displayMarathiName}
                    onChange={handleTextChange}
                  />
                  {errors.displayMarathiName && (
                    <div className="text-danger d-block mb-2">{errors.displayMarathiName}</div>
                  )}
                </div>
                {/* <div className="col-xl-6 mb-3">
                  <label htmlFor="marathiName" className="form-label">
                    Admin Name (MART) <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="marathiName"
                    name="marathiName"
                    value={medicine.marathiName}
                    onChange={handleTextChange}
                  // required
                  />
                  {errors.marathiName && (
                    <div className="text-danger d-block mb-2">{errors.marathiName}</div>
                  )}
                </div> */}
                <div className="col-xl-4 mb-3">
                  <label htmlFor="manufacturer" className="form-label">
                    Manufacturer <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="manufacturer"
                    name="manufacturer"
                    value={medicine.manufacturer}
                    onChange={handleTextChange}
                  // required
                  />
                  {errors.manufacturer && (
                    <div className="text-danger d-block mb-2">{errors.manufacturer}</div>
                  )}
                </div>
              </div>
              <div className="row">
                <div className="col-xl-4 mb-3">
                  <label className="form-label" htmlFor="type">
                    Type <span className="text-danger">*</span>
                  </label>
                  <Select
                    name="type"
                    options={medicineTypes}
                    value={
                      medicine.type && medicineTypes.length > 0
                        ? medicineTypes.find((opt) => opt.value === medicine.type) || {
                          value: medicine.type,
                          label: medicine.type,
                        }
                        : medicine.type
                          ? { value: medicine.type, label: medicine.type }
                          : null
                    }
                    onChange={(selectedOption) => {
                      setMedicine((prev) => ({
                        ...prev,
                        type: selectedOption?.value || "",
                        typeId: selectedOption?.id || "0",
                      }));
                      clearFieldError("type");
                    }}
                    placeholder="Select Type"
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        minHeight: "50px",
                        height: "50px",
                      }),
                      singleValue: (provided) => ({
                        ...provided,
                        lineHeight: "50px",
                      }),
                      dropdownIndicator: (provided) => ({
                        ...provided,
                        padding: "4px",
                      }),
                      indicatorSeparator: (provided) => ({
                        ...provided,
                        display: "none",
                      }),
                    }}
                  />
                  {errors.type && (
                    <div className="text-danger d-block mb-2">{errors.type}</div>
                  )}
                </div>
                <div className="col-xl-4 mb-3">
                  <label htmlFor="defaultDose" className="form-label">
                    Default Dose <span className="text-danger">*</span>
                  </label>
                  <Select
                    name="defaultDose"
                    options={defaultDoseOptions}
                    value={
                      medicine.defaultDose
                        ? { value: medicine.defaultDose, label: medicine.defaultDose }
                        : null
                    }
                    onChange={(selectedOption) => {
                      setMedicine((prev) => ({
                        ...prev,
                        defaultDose: selectedOption?.value || "",
                        defaultDoseId: selectedOption?.id || "",
                      }));
                      clearFieldError("defaultDose");
                    }}
                    placeholder="Select Default Dose"
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        minHeight: "50px",
                        height: "50px",
                      }),
                      singleValue: (provided) => ({
                        ...provided,
                        lineHeight: "50px",
                      }),
                      indicatorSeparator: () => ({ display: "none" }),
                    }}
                  />


                  {errors.defaultDose && (
                    <div className="text-danger d-block mb-2">{errors.defaultDose}</div>
                  )}
                </div>
                <div className="col-xl-4 mb-3">
                  <label htmlFor="defaultFrequency" className="form-label">
                    Default Frequency or Timing <span className="text-danger">*</span>
                  </label>
                  <Select
                    name="defaultFrequency"
                    options={frequencyOptions}
                    value={
                      medicine.defaultFrequency
                        ? { value: medicine.defaultFrequency, label: medicine.defaultFrequency }
                        : null
                    }
                    onChange={(selectedOption) => {
                      setMedicine((prev) => ({
                        ...prev,
                        defaultFrequency: selectedOption?.value || "",
                        defaultFrequencyId: selectedOption?.id || "0",
                      }));
                      clearFieldError("defaultFrequency");
                    }}
                    placeholder="Select Default Frequency"
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        minHeight: "50px",
                        height: "50px",
                      }),
                      singleValue: (provided) => ({
                        ...provided,
                        lineHeight: "50px",
                      }),
                      indicatorSeparator: () => ({ display: "none" }),
                    }}
                  />

                  {errors.defaultFrequency && (
                    <div className="text-danger d-block mb-2">{errors.defaultFrequency}</div>
                  )}
                </div>

              </div>
              <div className="row">

                <div className="col-xl-4 mb-3">
                  <label htmlFor="howToTakeIds" className="form-label">
                    How to take <span className="text-danger">*</span>
                  </label>
                  <Select
                    isMulti
                    name="howToTakeIds"
                    options={howToTakeOptions}   // make from redux like others
                    value={howToTakeOptions.filter(opt =>
                      medicine.howToTakeIds.includes(opt.value)
                    )}
                    onChange={(selectedOptions) => {
                      const values = selectedOptions
                        ? selectedOptions.map(opt => opt.value)
                        : [];
                    
                      setMedicine(prev => ({
                        ...prev,
                        howToTakeIds: values
                      }));
                    
                      clearFieldError("howToTakeIds");   // ✅ ADD THIS
                    }}
                    
                    placeholder="Select How To Take"
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        minHeight: "50px",
                      }),
                      indicatorSeparator: () => ({ display: "none" }),
                    }}
                  />


                  {errors.howToTakeIds && (
                    <div className="text-danger d-block mb-2">{errors.howToTakeIds}</div>
                  )}
                </div>
                <div className="col-xl-4 mb-3">
                  <label htmlFor="packageQty" className="form-label">
                    Package Quntity <span className="text-danger">*</span>
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    name="packageQty"
                    value={medicine.packageQty}
                    min="1"
                    step="1"
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === "" || Number(value) >= 1) {
                        handleTextChange(e);
                      }
                    }}
                  />
                  {errors.packageQty && (
                    <div className="text-danger d-block mb-2">{errors.packageQty}</div>
                  )}

                </div>

                <div className="col-xl-4 mb-3">
                  <label htmlFor="defaultInstructions" className="form-label">
                    Default Instructions <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="defaultInstructions"
                    name="defaultInstructions"
                    value={medicine.defaultInstructions}
                    onChange={handleTextChange}
                  // required
                  />
                  {errors.defaultInstructions && (
                    <div className="text-danger d-block mb-2">{errors.defaultInstructions}</div>
                  )}

                </div>
              </div>
              <div className="row">

                <div className="col-xl-4 mb-3">
                  <label htmlFor="unitOfMeasure" className="form-label">
                    Unit of Measure <span className="text-danger">*</span>
                  </label>
                  <Select
                    name="unitOfMeasure"
                    options={unitOfMeasureOptions}
                    value={
                      medicine.unitOfMeasure
                        ? { value: medicine.unitOfMeasure, label: medicine.unitOfMeasure }
                        : null
                    }
                    onChange={(selectedOption) => {
                      setMedicine((prev) => ({
                        ...prev,
                        unitOfMeasure: selectedOption?.value || "",
                        unitOfMeasureId: selectedOption?.id || "",
                      }));
                      clearFieldError("unitOfMeasure");
                    }}
                    placeholder="Select Unit of Measure"
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        minHeight: "50px",
                        height: "50px",
                      }),
                      singleValue: (provided) => ({
                        ...provided,
                        lineHeight: "50px",
                      }),
                      indicatorSeparator: () => ({ display: "none" }),
                    }}
                  />
                  {errors.unitOfMeasure && (
                    <div className="text-danger d-block mb-2">{errors.unitOfMeasure}</div>
                  )}
                </div>
                <div className="col-xl-4 mb-3">
                  <label htmlFor="valuePerUnit" className="form-label">
                    Value per Unit<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="valuePerUnit"
                    name="valuePerUnit"
                    min="1"
                    value={medicine.valuePerUnit}
                    onChange={handleTextChange}
                  //required
                  />
                  {errors.valuePerUnit && (
                    <div className="text-danger d-block mb-2">{errors.valuePerUnit}</div>
                  )}
                </div>

                <div className="col-xl-4 mb-3">
                  <label htmlFor="minimum_threshold" className="form-label">
                    Minimum Threshold <span className="text-danger">*</span>
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    id="minimum_threshold"
                    name="minimum_threshold"
                    value={medicine.minimum_threshold}
                    onChange={handleChange}
                    min="0"
                    step="1"
                    maxLength="100"
                  />
                  {errors.minimum_threshold && (
                    <div className="text-danger d-block mb-2">{errors.minimum_threshold}</div>
                  )}
                </div>
              </div>
              <div className="row">


                <div className="col-xl-4 mb-3">
                  <label htmlFor="pathyas" className="form-label">
                    Pathyas (Dietary Guidelines) <span className="text-danger">*</span>
                  </label>
                  <Select
                    name="pathyas"
                    options={pathyaOptions}
                    value={
                      medicine.pathyas
                        ? { value: medicine.pathyas, label: medicine.pathyas }
                        : null
                    }
                    onChange={(selectedOption) => {
                      setMedicine((prev) => ({
                        ...prev,
                        pathyas: selectedOption?.value || "",
                        pathyasId: selectedOption?.id || "",
                      }));
                      clearFieldError("pathyas");
                    }}
                    placeholder="Select Pathya"
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        minHeight: "50px",
                        height: "50px",
                      }),
                      singleValue: (provided) => ({
                        ...provided,
                        lineHeight: "50px",
                      }),
                      indicatorSeparator: () => ({ display: "none" }),
                    }}
                  />

                  {errors.pathyas && (
                    <div className="text-danger d-block mb-2">{errors.pathyas}</div>
                  )}
                </div>

                <div className="col-xl-4 mb-3">
                  <label htmlFor="anupan" className="form-label">
                    Anupan <span className="text-danger">*</span>
                  </label>
                  <Select
                    name="anupanId"
                    options={anupanOptions}
                    value={
                      medicine.anupanId
                        ? anupanOptions.find(o => o.value === medicine.anupanId)
                        : null
                    }
                    onChange={(selectedOption) => {
                      setMedicine((prev) => ({
                        ...prev,
                        anupanId: selectedOption?.value || "0",
                      }));
                      clearFieldError("anupanId");
                    }
                    }
                    placeholder="Select Anupan"
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        minHeight: "50px",
                        height: "50px",
                      }),
                      singleValue: (provided) => ({
                        ...provided,
                        lineHeight: "50px",
                      }),
                      indicatorSeparator: () => ({ display: "none" }),
                    }}
                  />

                  {errors.anupan && (
                    <div className="text-danger d-block mb-2">{errors.anupan}</div>
                  )}
                </div>


                <div className="col-xl-4 mb-3">
                  <label className="form-label" htmlFor="prescriptionRequired">
                    Prescription Required <span className="text-danger">*</span>
                  </label>
                  <Select
                    name="prescriptionRequired"
                    options={prescriptionOptions}
                    value={
                      prescriptionOptions.find(
                        (option) => option.value === medicine.prescriptionRequired
                      ) || null
                    }
                    onChange={(selectedOption) =>
                      handleTextChange({
                        target: {
                          name: "prescriptionRequired",
                          value: selectedOption?.value || "",
                        },
                      })
                    }
                    placeholder="Select Prescription"
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        minHeight: "50px",
                        height: "50px",
                      }),
                      singleValue: (provided) => ({
                        ...provided,
                        lineHeight: "50px",
                      }),
                      dropdownIndicator: (provided) => ({
                        ...provided,
                        padding: "4px",
                      }),
                      indicatorSeparator: (provided) => ({
                        ...provided,
                        display: "none",
                      }),
                    }}
                  />
                  {errors.prescriptionRequired && (
                    <div className="text-danger d-block mb-2">{errors.prescriptionRequired}</div>
                  )}
                </div>
                <div className="col-xl-4 mb-3">
                  <label className="form-label" htmlFor="status">
                    Status <span className="text-danger">*</span>
                  </label>
                  <Select
                    name="status"
                    options={[
                      { value: "", label: "Select Status" },
                      { value: "Active", label: "Active" },
                      { value: "Inactive", label: "Inactive" },
                      { value: "Delete", label: "Delete" },
                    ]}
                    value={
                      medicine.status
                        ? { value: medicine.status, label: medicine.status }
                        : null
                    }
                    onChange={(selectedOption) =>
                      handleTextChange({
                        target: { name: "status", value: selectedOption.value },
                      })
                    }
                    placeholder="Select Status"
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        minHeight: "50px",
                        height: "50px",
                      }),
                      singleValue: (provided) => ({
                        ...provided,
                        lineHeight: "50px",
                      }),
                      dropdownIndicator: (provided) => ({
                        ...provided,
                        padding: "4px",
                      }),
                      indicatorSeparator: (provided) => ({
                        ...provided,
                        display: "none",
                      }),
                    }}
                  />
                  {errors.status && (
                    <div className="text-danger d-block mb-2">{errors.status}</div>
                  )}
                </div>
                <div className="col-xl-4 mb-3">
                  <label className="form-label d-block">
                    Medicine Type
                  </label>

                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="internal"
                      checked={medicine.isInternal === true}
                      onChange={() =>
                        setMedicine((prev) => ({ ...prev, isInternal: true }))
                      }
                    />
                    <label className="form-check-label" htmlFor="internal">
                      Internal
                    </label>
                  </div>

                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="external"
                      checked={medicine.isInternal === false}
                      onChange={() =>
                        setMedicine((prev) => ({ ...prev, isInternal: false }))
                      }
                    />
                    <label className="form-check-label" htmlFor="external">
                      External
                    </label>
                  </div>
                </div>

              </div>

              <h5 className="mt-4" style={{ fontSize: "24px" }}>
                Medicine Price
              </h5>
              <div className="row mb-3">
                <div className="col-xl-2">
                  <label htmlFor="price" className="form-label">
                    Base Price <span className="text-danger">*</span>
                  </label>
                  <input
                    type="number"
                    placeholder="Enter Base Price"
                    className="form-control"
                    min={0.01}
                    step="0.01"
                    id="price"
                    name="price"
                    value={medicine.price}
                    onChange={handleChange}
                  />
                  {errors.price && (
                    <div className="text-danger d-block mb-2">{errors.price}</div>
                  )}
                </div>
                <div className="col-xl-2">
                  <label htmlFor="cgst" className="form-label">
                    CGST (%) <span className="text-danger">*</span>
                  </label>
                  <input
                    type="number"
                    placeholder="Enter CGST "
                    className="form-control"
                    min={0.01}
                    step="0.01"
                    id="cgst"
                    name="cgst"
                    value={medicine.cgst}
                    onChange={handleChange}
                  />
                  {errors.cgst && (
                    <div className="text-danger d-block mb-2">{errors.cgst}</div>
                  )}
                </div>
                <div className="col-xl-2">
                  <label htmlFor="sgst" className="form-label">
                    SGST (%) <span className="text-danger">*</span>
                  </label>
                  <input
                    type="number"
                    placeholder="Enter SGST "
                    className="form-control"
                    min={0.01}
                    step="0.01"
                    id="sgst"
                    name="sgst"
                    value={medicine.sgst}
                    onChange={handleChange}
                  />
                  {errors.sgst && (
                    <div className="text-danger d-block mb-2">{errors.sgst}</div>
                  )}
                </div>
                <div className="col-xl-2">
                  <label htmlFor="gst" className="form-label">
                    GST (%) <span className="text-danger">*</span>
                  </label>
                  <input
                    type="number"
                    placeholder="GST (Read Only)"
                    className="form-control"
                    min={0.01}
                    step="0.01"
                    id="gst"
                    name="gst"
                    value={medicine.gst}
                    onChange={handleChange}
                    disabled
                  />
                  {errors.gst && (
                    <div className="text-danger d-block mb-2">{errors.gst}</div>
                  )}
                </div>
                <div className="col-xl-2">
                  <label htmlFor="finalPricecgstsgst" className="form-label">
                    Final Price (GST)
                  </label>
                  <input
                    type="number"
                    placeholder="Enter Final Price (CGST+SGST) "
                    className="form-control"
                    min={0.01}
                    step="0.01"
                    id="finalPricecgstsgst"
                    name="finalPricecgstsgst"
                    value={medicine.finalPricecgstsgst}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={loading || fetching}
              >
                {loading ? (
                  <>
                    <Loader size="sm" />
                    <span className="ms-2">Submitting...</span>
                  </>
                ) : (
                  id ? "Update Medicine" : "Add Medicine"
                )}
              </button>

            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddMedicine;
